import { render, staticRenderFns } from "./DateTable.vue?vue&type=template&id=23ccc1c8&"
import script from "./DateTable.vue?vue&type=script&lang=js&"
export * from "./DateTable.vue?vue&type=script&lang=js&"
import style0 from "../../styles/date-table.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports